module.exports = __webpack_public_path__ + "static/media/icon_estado_pendiente.ce4903ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_estado_pendiente.svg
// module id = 622
// module chunks = 0